import { render, staticRenderFns } from "./VehicleEditView.vue?vue&type=template&id=b987be52"
import script from "./VehicleEditView.vue?vue&type=script&lang=js"
export * from "./VehicleEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports